module.exports = __webpack_public_path__ + "static/img/thePublic.9110a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thePublic/thePublic.png
// module id = wic4
// module chunks = 1